
import { Union } from "../../fable_modules/fable-library-js.5.3.0/Types.js";
import { union_type, string_type } from "../../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { value as value_13 } from "../../fable_modules/fable-library-js.5.3.0/Option.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { CoverImage_renditionDimensions, CoverImage_altText } from "../CoverImage.js";
import { opacity_opacity50, fontWeight_fontMedium, fontSize_textXs, padding_px2, alignItems_itemsCenter, display_flex, width_wFull, tw } from "../../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.3.0/Seq.js";
import { empty, singleton as singleton_1, ofArray } from "../../fable_modules/fable-library-js.5.3.0/List.js";
import { minHeight_minH12, textColor_textWarning800, backgroundColor_bgWarning50, borderRadius_roundedFull } from "../TailwindExtensions.js";
import { createElement } from "react";
import { IconWeight, IconSize, IconName, icon } from "../Icons.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.3.0/Util.js";

export class PublicCover extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NoCover", "VisibleCover", "HiddenCoverForModerator"];
    }
}

export function PublicCover_$reflection() {
    return union_type("Shared.CoverImageView.PublicCover", [], PublicCover, () => [[], [["url", string_type]], [["url", string_type]]]);
}

/**
 * What the public card shows. `moderatorCover` is Some only when the moderation status for this
 * challenge has loaded (moderators alone); it is authoritative and refreshed after every moderation
 * action. Everyone else sees only a visible cover. The owner on the public page is a member of the
 * public here, so a hidden cover is not shown to them.
 */
export function publicCover(moderatorCover, cover) {
    let matchResult, moderated, url;
    if (moderatorCover == null) {
        if (cover != null) {
            if (cover.Hidden == null) {
                matchResult = 2;
                url = cover.Url;
            }
            else {
                matchResult = 3;
            }
        }
        else {
            matchResult = 3;
        }
    }
    else if (value_13(moderatorCover) == null) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        moderated = value_13(moderatorCover);
    }
    switch (matchResult) {
        case 0:
            if (moderated.Hidden == null) {
                return new PublicCover(1, [moderated.Url]);
            }
            else {
                return new PublicCover(2, [moderated.Url]);
            }
        case 1:
            return new PublicCover(0, []);
        case 2:
            return new PublicCover(1, [url]);
        default:
            return new PublicCover(0, []);
    }
}

function coverImg(collapseContainerOnError, url, title, extraClasses) {
    return HtmlHelper_createElement("img", ofArray([["src", url], ["alt", CoverImage_altText(title)], ["width", CoverImage_renditionDimensions.Width], ["height", CoverImage_renditionDimensions.Height], ["fetchpriority", "high"], ["className", tw(toList(delay(() => append(singleton("aspect-[1200/630]"), delay(() => append(singleton(width_wFull), delay(() => append(singleton("object-cover"), delay(() => append(singleton("object-center"), delay(() => extraClasses)))))))))))], ["onError", (e) => {
        const img = e.target;
        const collapsed = collapseContainerOnError ? img.parentElement : img;
        collapsed.setAttribute("style", "display: none");
    }]]));
}

/**
 * The cover <img>; a failed load collapses its container.
 */
export function image(url, title, extraClasses) {
    return coverImg(true, url, title, extraClasses);
}

const hiddenBadge = HtmlHelper_createElement("span", ofArray([["className", tw(ofArray(["absolute", "top-3", "left-3", display_flex, alignItems_itemsCenter, "gap-1.5", padding_px2, "py-0.5", borderRadius_roundedFull, fontSize_textXs, fontWeight_fontMedium, backgroundColor_bgWarning50, textColor_textWarning800]))], ["children", [createElement(icon, {
    name: new IconName(30, []),
    size: new IconSize(0, []),
    weight: new IconWeight(0, []),
}), HtmlHelper_createElement("span", singleton_1(["children", singleton_1("Hidden from public")]))]]]));

/**
 * Card-top cover: rounded-t, no padding. A hidden cover is dimmed and badged for the moderator.
 */
export function cardTop(cover, title) {
    switch (cover.tag) {
        case 1:
            return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray(["relative", "rounded-t-lg", "overflow-hidden"]))], ["children", [image(cover.fields[0], title, empty())]]]));
        case 2:
            return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray(["relative", "rounded-t-lg", "overflow-hidden", minHeight_minH12]))], ["children", [coverImg(false, cover.fields[0], title, singleton_1(opacity_opacity50)), hiddenBadge]]]));
        default:
            return defaultOf();
    }
}

//# sourceMappingURL=CoverImageView.js.map
